<template>
  <AiAssistantPanel
    ai-base-url="/corsair/ai"
    :record="record"
    :record-label="label"
    :domain-id="selectedDomainId"
    :user-name="currentUser?.user?.displayName?.split(' ')[0]"
  />
</template>

<script lang="ts" setup>
import { useRecordContext } from '@/composables/useRecordContext';
import { useCurrentUserStore } from '@/stores/CurrentUser';

import AiAssistantPanel from '@rygen/rygen-ui/components/aiAssistant/AiAssistantPanel.vue';

const { currentUser, selectedDomainId } = useCurrentUserStore();
const { record, label } = useRecordContext();
</script>
